<template>
  <div class="d-flex">
    <v-select
      v-model="provider"
      :items="providers"
      label="Gateway"
      prepend-icon="mdi-account-credit-card-outline"
      hide-details
      solo-inverted
      return-object
      dense
    />
  </div>
</template>

<script>
export default {
  data: () => ({
    provider: null,
  }),
  watch: {
    provider(val) {
      this.$store.commit("setPaymentProvider", val);
    },
  },
  computed: {
    providers() {
      if (!Array.isArray(this.$store.state.operator.payment_providers)) {
        return [];
      }

      return [
        { text: this.$t("all"), value: "all" },
        ...this.$store.state.operator.payment_providers,
      ];
    },
  },
};
</script>
